import { UnitStateData, UnitStateGroupEnum } from '@mark43/cad-api';
import { useMemo } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';
import { useApplicationType } from './use-application-type';

export function useEnRouteStates(
    isIncomingEventAed: boolean = false
): {
    enRouteState?: UnitStateData;
    alternateEnRouteState?: UnitStateData;
} {
    const unitAssignment = useUnitAssignment();
    const { unitStateDataById } = useBootstrapState();
    const { isFirstResponder } = useApplicationType();

    const unitStateDatum = useMemo(() => Object.values(unitStateDataById), [unitStateDataById]);

    const dispatchedStateGroup = isIncomingEventAed
        ? UnitStateGroupEnum.SYSTEM_DISPATCHED.name
        : UnitStateGroupEnum.DISPATCHED.name;

    const enRouteState = unitStateDatum.find(
        (usd) =>
            usd.unitStateGroup === 'EN_ROUTE' &&
            usd.agencyTypeGlobalAttrId === unitAssignment?.unitAgencyTypeGlobalAttrId
    );

    const alternateEnRouteState = unitStateDatum.find(
        (usd) =>
            usd.unitStateGroup === 'EN_ROUTE_ALTERNATE' &&
            usd.agencyTypeGlobalAttrId === unitAssignment?.unitAgencyTypeGlobalAttrId
    );

    const dispatchedState = unitStateDatum.find(
        (usd) =>
            usd.unitStateGroup === dispatchedStateGroup &&
            usd.agencyTypeGlobalAttrId === unitAssignment?.unitAgencyTypeGlobalAttrId
    );

    // the `transitionToUnitStateIds` is considering just the dispatcher ones in the BE (and it's deprecated), thus it can't be used in here
    const transitionToUnitStateIds = isFirstResponder
        ? dispatchedState?.firstResponderTransitionToUnitStateIds
        : dispatchedState?.dispatcherTransitionToUnitStateIds;

    const dispatchedTransitionToAlternateEnRoute = transitionToUnitStateIds?.some(
        (stateId) => stateId === alternateEnRouteState?.id
    );

    const dispatchedTransitionToEnRoute = transitionToUnitStateIds?.some(
        (stateId) => stateId === enRouteState?.id
    );

    return {
        enRouteState: dispatchedTransitionToEnRoute ? enRouteState : undefined,
        alternateEnRouteState: dispatchedTransitionToAlternateEnRoute
            ? alternateEnRouteState
            : undefined,
    };
}
